import { StrictMode, lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { ConfigurationMissing } from './components/ConfigurationMissing'
import { registerChunkLoadRecovery } from './lib/chunkLoadRecovery'
import { env } from './lib/env'
import { registerPwaInstallListeners } from './platform/pwaInstall'
import { emitServiceWorkerUpdateAvailable, setServiceWorkerApplyUpdate } from './platform/swUpdateClient'

registerChunkLoadRecovery()
registerPwaInstallListeners()

const App = lazy(() => import('./App.tsx'))

const rootEl = document.getElementById('root')
if (!rootEl) {
  throw new Error('#root missing')
}

function LoadingSplash() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-[var(--swish-bg-base)] text-sm text-slate-400">
      Opening Swish…
    </div>
  )
}

if (import.meta.env.PROD) {
  void import('virtual:pwa-register').then(({ registerSW }) => {
    const applyUpdate = registerSW({
      immediate: true,
      onNeedRefresh() {
        emitServiceWorkerUpdateAvailable()
      },
      onOfflineReady() {},
    })
    setServiceWorkerApplyUpdate(applyUpdate)
  })
}

createRoot(rootEl).render(
  <StrictMode>
    <Suspense fallback={<LoadingSplash />}>
      {env.isProd && !env.isSupabaseConfigured ? <ConfigurationMissing /> : <App />}
    </Suspense>
  </StrictMode>,
)
